/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fondo[_ngcontent-%COMP%]{padding-top:5px}.labelCobrament[_ngcontent-%COMP%]{margin-top:10px}.labelCobrament1[_ngcontent-%COMP%]{margin-left:-28px!important}.pocedntaje[_ngcontent-%COMP%]{margin-left:-37px!important;margin-top:-4px}"];
export { styles as styles };
